export default __webpack_public_path__ + "static/media/ExcursionsandTours.98cdbff9.jpeg";